import { usePatientForm } from '../../context/PatientFormContext';

export default function FormHeader() {
  const { patient, consent } = usePatientForm();

  return (
    <div className="form-header">
      <div className="form-header-icon">📋</div>

      <div className="form-header-text">
        <h2>{patient ? 'Edit ADR Report' : 'ADR Self-Reporting Form'}</h2>
        <p>{patient ? 'Update patient ADR details' : 'Adverse Drug Reaction — Confidential Report'}</p>
      </div>

      {consent === true && (
        <span
          className={`badge ${patient ? 'badge-warning' : 'badge-success'}`}
          style={{ marginLeft: 'auto' }}
        >
          {patient ? 'Editing Report' : '✓ Consent Given'}
        </span>
      )}
    </div>
  );
}
